export function navbarClickHandler() {
    const leftNavBtn = document.querySelector('.toggle-button-left') as HTMLButtonElement;
    const rightNavBtn = document.querySelector('.toggle-button-right') as HTMLButtonElement;
    const navMenu = document.querySelector('.mobile-navbar-nav') as HTMLElement;
    const mainWrap = document.querySelector('.main-wrap') as HTMLElement;
    const footer = document.querySelector('.footer-wrap') as HTMLElement;
    if (leftNavBtn) {
        leftNavBtn.addEventListener('click', () => {
            if (footer) {
                if (footer.classList.contains('move-to-right')) {
                    footer.classList.remove('move-to-right', 'move-shadow');
                } else {
                    footer.classList.add('move-to-right', 'move-shadow');
                }
            }
        })
    }
    if (rightNavBtn) {
        rightNavBtn.addEventListener('click', () => {
            if (footer) {
                if (footer.classList.contains('move-to-left')) {
                    footer.classList.remove('move-to-left', 'move-shadow');
                } else {
                    footer.classList.add('move-to-left', 'move-shadow');
                }
            }
        })
    }
    if (mainWrap) {
        mainWrap.addEventListener('click', e => {
            if ((e.target as HTMLElement).classList.contains('toggle-button-left') || (e.target as HTMLElement).classList.contains('icon-navigation-menu') || (e.target as HTMLElement).classList.contains('toggle-button-right') || (e.target as HTMLElement).classList.contains('icon-single-neutral-circle')) {
                return;
            }
            if (footer) {
                if (footer.classList.contains('move-to-right')) {
                    footer.classList.remove('move-to-right', 'move-shadow');
                }
                if (footer.classList.contains('move-to-left')) {
                    footer.classList.remove('move-to-left', 'move-shadow');
                }
            }
        })
    }
    if (footer) {
        footer.addEventListener('click', e => {
            if (footer.classList.contains('move-to-right')) {
                footer.classList.remove('move-to-right', 'move-shadow');
            }
            if (footer.classList.contains('move-to-left')) {
                footer.classList.remove('move-to-left', 'move-shadow');
            }
        })
    }
    if (navMenu) {
        navMenu.addEventListener('click', () => {
            if (footer.classList.contains('move-to-right')) {
                footer.classList.remove('move-to-right', 'move-shadow');
            }
        })
    }
}
